import React, { useState, useEffect } from 'react';
import { getReportAssignmentRecips, assignReport } from 'utils/ResourcesUtils';
import { List, ListItem, Checkbox, ListItemText } from '@material-ui/core';
import CenteredError from 'components/Shared/CenteredError';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';

const AssignRecipientsList = ({ parentRAssignmentId }) => {
  // re-fetches recips when re-set
  const [ reloadListener, setReloadListener ] = useState(new Date());
  // loading indicator state
  const [loadings, setLoadings] = useState({ recips: false });
  // error state
  const [error, setError] = useState({ recips: false });
  // local state storage for recips fetched from api
  const [recips, setRecips] = useState([]);

  /**
   * fetches recipients based on selectedResource prop
   */
  useEffect(() => {
    let mounted = true;
    const asyncEffect = async () => {
      setLoadings(old => ({ ...old, recips: true }));
      const recips = await getReportAssignmentRecips(parentRAssignmentId);
      if (recips.success) {
        mounted && setRecips(recips.data);
        setLoadings(old => ({ ...old, recips: false }));
      } else {
        setError(old => ({...old, recips: true}));
      };
    };

    const clearAssignments = () => setRecips([]);

    parentRAssignmentId ? asyncEffect() : clearAssignments();

    return function cleanUP() { mounted = false; setLoadings(old => ({ ...old, recips: false })) };

  }, [parentRAssignmentId, reloadListener]);

  /**
   * reloads recipients and thus the component basically.
   */
  const reload = async ({delay=1000}) => {
    setError(old => ({...old, recips: false}));
    setLoadings(old => ({ ...old, recips: true }));
    await new Promise(res => setTimeout(() => {res()}, delay));
    setReloadListener(new Date());
  };

  /**
   * handles checkbox clicks and updates report assignment through API for selected user.
   * @param { event } event 
   */
  const handleClick = async (e) => {
    // get values from target element;
    const { checked, value } = e.target;
    // find recipient data;
    const recip = recips.find(r => r.email === value);
    // set 'value' based on checkbox
    recip.value = checked;
    // set loading indicator to show operation in progress
    setLoadings(old => ({ ...old, recips: true }));
    // update value through api
    const update = await assignReport(parentRAssignmentId, recip);
    // success, reload recip data, else reset loading indicator and show error;
    update.success ? reload({delay: 0}) : setError(old => ({...old, recips: true}));

  };

  return (
    parentRAssignmentId ?
      !loadings.recips ?
        <List>
          {recips.map(r => (
            <ListItem key={r.email}>
              <Checkbox
                checked={r.value}
                onClick={handleClick}
                value={r.email}
              />
              <ListItemText id={r.email} primary={r.name} />
            </ListItem>
          ))}
        </List>
        : !error.recips ? <CenteredCircularProgress /> : <CenteredError refresh={reload} />
      : null
  )
}


export default AssignRecipientsList;